import { PropsWithChildren, createContext, useContext, useMemo } from "react"

import { PrefetchData, PrefetchKey } from "./type"

interface PrefetchState {
    data: Partial<PrefetchData>
}
const PrefetchContext = createContext<PrefetchState>({ data: {} })

export const PrefetchProvider = ({ children, data }: PropsWithChildren<{ data: Partial<PrefetchData> }>) => {
    const value = useMemo(() => ({ data }), [data])
    return <PrefetchContext.Provider value={value}>{children}</PrefetchContext.Provider>
}

export const usePrefetch = <K extends PrefetchKey>(key: K) => ({
    data: useContext(PrefetchContext)?.data?.[key] as PrefetchData[K],
})
